import React from 'react';

// eslint-disable-next-line max-len
const NTW_LOGO = '/themes/theme/ntw/logo.svg';
const NTW_DARK_LOGO = '/themes/theme/ntw/logo.svg';

const NTWTheme = {
  headerLogo: {
    src: NTW_LOGO,
    alt: 'NTW Logo',
    size: 70,
  },
  darkLogo: {
    src: NTW_DARK_LOGO,
    alt: 'NTW Logo',
    size: 70,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #E94E1A',
    height: 80,
  },
  title: 'NTW',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src={NTW_DARK_LOGO} alt="NTW Logo"
      />
      <br /><br />
      {/* <h3>FLYT</h3> */}
    </div>
  ),
  shareSite: 'https://ntwr.dyzio.co',
};

export default NTWTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/ntw.js
 **/